import $ from 'jquery';

$(document).ready(function () {
  acfTeamBlock();
});

function acfTeamBlock() {
  $('.js-acf-team-block').each(function () {});
}
